import type { User } from '@ztechapps/common.contract'

// The notifications addressed to the user: their own (`user` scope) and their tenant's (`tenant` scope).
export const buildNotificationScopeFilter = (user?: Pick<User, '_id' | 'tenantId'>) => ({
  $or: [
    { 'scope.key': 'user', 'scope.value': user?._id },
    { 'scope.key': 'tenant', 'scope.value': user?.tenantId },
  ],
})
